var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    staticStyle: { overflow: "scroll" },
    attrs: {
      title: _vm.$t("Processing"),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      draggable: !_vm.loading
    },
    on: { close: _vm.closeProcessing },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [
            _c("ProcessingSVG", { staticClass: "floating-container-svg" })
          ]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c("processing-list", {
              attrs: {
                "processing-items": _vm.preProcessingList,
                pr_code: _vm.pr_code_pre
              },
              on: {
                "run-processing": function($event) {
                  return _vm.executeProcessing("pre", $event)
                },
                "change-to-default": function($event) {
                  return _vm.changeToDefault($event, "pre")
                }
              }
            }),
            _vm._v(" "),
            _vm.disableDivider
              ? _c("v-divider", { staticStyle: { margin: "0 20px" } })
              : _vm._e(),
            _vm._v(" "),
            _c("processing-list", {
              attrs: {
                "processing-items": _vm.postProcessingList,
                pr_code: _vm.pr_code_post
              },
              on: {
                "run-processing": function($event) {
                  return _vm.executeProcessing("post", $event)
                },
                "change-to-default": function($event) {
                  return _vm.changeToDefault($event, "post")
                }
              }
            }),
            _vm._v(" "),
            _c("loading-spinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "#4fa2b7",
                height: 30,
                width: 30
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06afbfb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06afbfb6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Processing/ProcessingWindow.vue
// module id = null
// module chunks = 